import { useMemo, useState } from "react";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { useActionPlansEditionContext } from "../../context/ActionPlansEditionContext";
import dayjs, { Dayjs } from "dayjs";

interface IUseActionPlanDueDateCellResult {
    isEditing: boolean;
    dueDate: Dayjs | null;
    handleDueDateChange: (date: Dayjs | null) => void;
}

export const useActionPlanDueDateCell = (row: IActionPlan): IUseActionPlanDueDateCellResult => {
    const { edit, setEdit } = useActionPlansEditionContext();

    const existingEdition = useMemo(() => edit.findIndex((e) => e.id === row.action_plan_id), [edit, row]);
    const dueDateChanges = useMemo(
        () => (existingEdition !== -1 ? edit[existingEdition]?.changes?.due_date : undefined),
        [edit, existingEdition],
    );

    const initialDueDate = dueDateChanges
        ? dayjs(dueDateChanges)
        : row.due_date
        ? dayjs(row.due_date)
        : null;
    const [dueDate, setDueDate] = useState<Dayjs | null>(initialDueDate);

    const handleDueDateChange = (date: Dayjs | null) => {
        setDueDate(date);

        if (existingEdition !== -1) {
            setEdit((prevEdit) => {
                const newEdit = [...prevEdit];
                newEdit[existingEdition] = {
                    ...newEdit[existingEdition],
                    changes: {
                        ...newEdit[existingEdition]?.changes,
                        due_date: date ? date.toISOString() : undefined,
                    },
                };
                return newEdit;
            });
        }
    };

    const isEditing = existingEdition !== -1;

    return {
        isEditing,
        dueDate,
        handleDueDateChange,
    };
};

